import rill from "rill";
import set from "@rill/set";
import MSBUniversityController from "./msb-university.controller.js";

const MsbUniversity = (app) => {
  app.at(
    "/msb-university/*",
    rill()
      .use(set("heading", ["Coaching", "MSB University"]))
      .setup((app) => {
        app.get("/", MSBUniversityController);
      })
  );
};

export default MsbUniversity;
